import styled from 'styled-components';

export const ChatTabsSC = styled.div`
  background: #fff;
  padding: 8px;
`;
